import { z } from "zod";

export const screenTagCreateSchema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
});

export const screenTagUpdateSchema = z.object({
  name: z.string().min(1, "Name is required").optional(),
  description: z.string().optional(),
});

export type ScreenTagFormData = z.infer<typeof screenTagCreateSchema>;
export type ScreenTagUpdateFormData = z.infer<typeof screenTagUpdateSchema>;

export interface ScreenTagRequest {
  name: string;
  description?: string;
}

export interface ScreenTag {
  id: string;
  name: string;
  description?: string;
  type?: string | null;
  tenantId: string;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ScreenTagsResponse {
  screenTags: ScreenTag[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface ScreenTagFilters {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface UpdateScreenTagPayload {
  id: string;
  screenTag: ScreenTagUpdateFormData;
}
